module.exports = __webpack_public_path__ + "img/0Q3A7250_P_L_Wood.aa722ca6.jpg";